import { Controller } from "@hotwired/stimulus";

// Remembers whether a collapsible sidebar section is open, keyed by section
// name rather than by record, so someone who always wants Payments expanded
// gets it expanded on the next creator they open — not just on this one.
//
// The server renders a sensible default open/closed state; this only overrides
// it once the user has expressed a preference by toggling the section.
export default class extends Controller {
  static values = { key: String };

  connect() {
    this.boundPersist = this.persist.bind(this);
    this.element.addEventListener("toggle", this.boundPersist);

    const stored = this.storedState();
    if (stored !== null) this.element.open = stored;
  }

  disconnect() {
    if (this.boundPersist) {
      this.element.removeEventListener("toggle", this.boundPersist);
    }
  }

  persist() {
    try {
      localStorage.setItem(this.storageKey(), this.element.open ? "1" : "0");
    } catch (e) {
      // Private browsing / full quota — the section still works, it just
      // won't be remembered.
    }
  }

  storedState() {
    try {
      const value = localStorage.getItem(this.storageKey());
      if (value === null) return null;
      return value === "1";
    } catch (e) {
      return null;
    }
  }

  storageKey() {
    return `ik-aside-section:${this.keyValue}`;
  }
}
